import { IconButton } from '@material-ui/core';
import {
  AirplaneIcon,
  AllIconTwoTone,
  CheckedCalendarIcon,
  LikeIconTwoTone,
  MessageRoundIcon,
  PriceTagIcon,
  Typography,
} from '@room-match/shared-ui-components';
import React, { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
import { navigateToRoute } from 'shared/utils/navigateToRoute';
import { ActionButton, ActionsContainer, StatusTabs, Tab, useStyles } from './Events.styles';
import EventsList from './EventsList/EventsList';

const mockData = [
  {
    name: 'Ronald Welch',
    number: '(310) 310-3100',
    email: 'henryfox@gmail.com',
    agency: 'AHC Casting',
    project: 'Coke Cola',
    role: "Farmer's Friend",
    type: 'Booking',
    audition_time: '3:00PM PST',
    audition_date: '24 Aug 2023',
    status: '',
    action_time: '',
    message: 'Work commitments and other personal issues',
    remarks: '',
  },
  {
    name: 'Ronald Welch',
    number: '(310) 310-3100',
    email: 'henryfox@gmail.com',
    agency: 'AHC Casting',
    project: 'Coke Cola',
    role: "Farmer's Friend",
    type: 'Fitting',
    audition_time: '3:00PM PST',
    audition_date: '24 Aug 2023',
    status: '',
    action_time: '',
    message: 'Work commitments and other personal issues',
    remarks: '',
  },
  {
    name: 'Ronald Welch',
    number: '(310) 310-3100',
    email: 'henryfox@gmail.com',
    agency: 'AHC Casting',
    project: 'Coke Cola',
    role: "Farmer's Friend",
    type: 'Travel',
    audition_time: '3:00PM PST',
    audition_date: '24 Aug 2023',
    status: '',
    action_time: '',
    message: 'Work commitments and other personal issues',
    remarks: '',
  },
];

const tabs = [
  {
    name: 'all',
    header: 'All',
    number: 9,
    icon: <AllIconTwoTone />,
    component: <div>All</div>,
  },
  {
    name: 'bookings',
    header: 'Bookings',
    number: 9,
    icon: <CheckedCalendarIcon className="primary" />,
    component: <div>All</div>,
  },
  {
    name: 'fittings',
    header: 'Fittings',
    number: 1,
    icon: <LikeIconTwoTone />,
    component: <div>All</div>,
  },
  {
    name: 'travelling',
    header: 'Travelling',
    number: 1,
    icon: <AirplaneIcon />,
    component: <div>All</div>,
  },
];

type Props = {
  tab: string;
};

const Events: React.FC<Props> = ({ tab }) => {
  const { childTab } = useParams() as { childTab: string };
  const history = useHistory();
  const classes = useStyles();

  const getActiveTab = useMemo(() => {
    return tabs.find((_tab) => _tab.name === childTab)?.component;
  }, [childTab]);

  const handleRequestTabChange = (tab: string, childTab: string) => {
    history.push(navigateToRoute.toWorksheetChildTab(tab, childTab));
  };

  return (
    <div>
      <StatusTabs>
        {tabs.map((i) => {
          return (
            <Tab className={i.name !== childTab ? classes.inactive : ''}>
              <IconButton onClick={() => handleRequestTabChange(tab, i.name)}>{i.icon}</IconButton>
              <Typography>{i.number}</Typography>
              <Typography color="mainGrey" fontSize={12}>
                {i.header}
              </Typography>
            </Tab>
          );
        })}
      </StatusTabs>
      <ActionsContainer>
        <Typography fontSize={18}>0 Talent Selected</Typography>
        <ActionButton color="secondary" startIcon={<MessageRoundIcon />} className={classes.inactive}>
          Message
        </ActionButton>
        <ActionButton color="secondary" startIcon={<PriceTagIcon className="primary" />} className={classes.inactive}>
          Tab
        </ActionButton>
        <ActionButton color="secondary" className={classes.inactive}>
          Clear Selected
        </ActionButton>
        <ActionButton color="secondary">Clear All Completed</ActionButton>
      </ActionsContainer>
      <EventsList data={mockData} tab={tab} />
    </div>
  );
};

export default Events;
